import React,{ useState } from "react";
import "./token.css";
import { Select } from "@chakra-ui/react";
import TokenInfoSec from "./TokenInfoSec";
import TaxConfig from "./TaxConfig";
import TokenConfigs from "./TokenConfigs";
import LpLock from "./LpLock";
import LaunchProt from "./LaunchProt";
import TaxMax from "./TaxMax";

const CreateToken = ({formValues, setFormValues}) => {


  return (
    <div className="create-token-main">
      <div className="heading">Create Token </div>
      <hr />
      <div className="selection">
        <div className="heading sel-head">Select</div>
        <div className="selector">
          <Select size="sm" onChange={(e) => setFormValues({...formValues, selectContract: e.target.value})}>
            <option value="TaxContract">Tax Contract</option>
            <option value="Standart Token">Standart Token</option>
            <option value="Safemoon Contract">Safemoon Contract</option>
            <option value="Baby Contract">Baby Contract</option>
            <option value="BuyBack Baby Contract">BuyBack Baby Contract</option>
          </Select>
        </div>
      </div>
      <TokenInfoSec formValues={formValues} setFormValues={setFormValues} />
      <TaxConfig formValues={formValues} setFormValues={setFormValues} />
      <TaxMax formValues={formValues} setFormValues={setFormValues} />
      <TokenConfigs formValues={formValues} setFormValues={setFormValues} />
      <LpLock formValues={formValues} setFormValues={setFormValues} />
      <LaunchProt formValues={formValues} setFormValues={setFormValues} />
    </div>
  );
};

export default CreateToken;
